export default {
  itemsPerPage: 50,
  itemsPerPageOptions: [10, 15, 20, 25, 50, 100]
}
